export default {
      id: "dashboard-usage",
      viewBox: "0 0 132 87",
      url: __webpack_public_path__ + "icons-sprite.ef97e87.svg#dashboard-usage",
      toString: function () {
        return this.url;
      }
    }